import React from "react"
import { getData, getAnimation, getSuiteColor } from "../../utils/page"
import { Row, Col } from "react-bootstrap"
import { connect } from "react-redux"
import styled from "styled-components"
import Parser from "html-react-parser"
import ticket from "../../images/ticket_google.svg"
import logo from "../../images/logo-google-cloud.svg"
import nube from "../../images/nube.svg"
import { Link } from "gatsby"

let SectionGoogle = props => {
  const {
    app: { lang },
    location,
  } = props

  const content = getData(location, lang)
  const animation = getAnimation(location)
  const color = getSuiteColor(location)

  return (
    <>
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <img
          src={nube}
          style={{
            position: "absolute",
            width: "100%",
            height: "auto",
            maxWidth: "600px",
            bottom: "0",
            right: "0",
          }}
        />

        <RowMain className="row " location="cloud">
          <ColText className="col-xl-6">
            <img
              src={logo}
              style={{
                width: "100%",
                height: "auto",
                maxWidth: "400px",
              }}
            />
            <h1>{content.sectionGoogle.title}</h1>
            <p style={{ marginBottom: "4rem" }}>
              {Parser(content.sectionGoogle.rest)}
            </p>
            <BtnTalk to="cloud/google-cloud-partner">
              {content.sectionGoogle.button}
            </BtnTalk>
          </ColText>
          <Col xl={4} style={{ height: "100%", alignSelf: "center" }}>
            <ul>
              {content.sectionGoogle.list.map(e => (
                <li>
                  <ColTicket>
                    <img src={ticket} />
                  </ColTicket>
                  <ColList>
                    <p>{e.name}</p>
                  </ColList>
                </li>
              ))}
            </ul>
          </Col>
        </RowMain>
      </div>
    </>
  )
}

const RowMain = styled.div`
  margin-left: auto;
  margin-right: auto;
  background-color: #0248a5;
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: 4rem;
  padding-bottom: 4rem;
  && h1 {
    font-size: 2rem;

    font-weight: bold;
  }
  && p {
    font-size: 1rem;
  }
  && ul {
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    display: flex;
    @media (max-width: 1200px) {
      padding: 0;
    }
  }
  && li {
    display: flex;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
  }
`

const ColText = styled.div`
  padding: 5rem 5rem 5rem 8rem;
  color: white;
  align-self: center;
  height: 100%;
  @media (max-width: 1200px) {
    text-align: center;
    padding: 5rem 4rem 5rem 4rem;
  }
  @media (max-width: 500px) {
    padding: 5rem 2rem 5rem 2rem;
  }
`
const ColTicket = styled.div`
  width: 10%;
  && img {
    width: 100%;
    height: auto;
    max-width: 35px;
  }
  @media (max-width: 600px) {
    width: 15%;
  }
`
const ColList = styled.div`
  width: 90%;
  && p {
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 500px) {
      font-size: 1.2rem;
    }
  }
  @media (max-width: 1200px) {
    width: 30%;
  }
  @media (max-width: 600px) {
    width: 80%;
  }
`

const BtnTalk = styled(Link)`
  background-color: #ffffff !important;
  text-decoration: none;
  text-align: center;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1rem;
  cursor: pointer;
  border-width: 0px;
  margin-top: 2rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #1a73e8;
  :hover,
  :focus,
  :visited:active {
    background-color: rgb(194, 194, 194) !important;
    border-color: ${props => props.inputcolor} !important;
    text-decoration: none;
  }
`

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    changeLang: lang => dispatch({ type: "SET_LANGUAGE", payload: lang }),
    showModalFunc: show => dispatch({ type: "SHOW_MODAL", payload: show }),
  }
}

SectionGoogle = connect(mapStateToProps, mapDispatchToProps)(SectionGoogle)

export default SectionGoogle
